import SectionWiseFetchDetailsTypes from './SectionWiseFetchDetails.types';

export const sectionWiseFetchStart = (data: any) => ({
	type: SectionWiseFetchDetailsTypes.SECTION_WISE_FETCH_START,
	payload: data,
});

export const sectionWiseFetchSuccess = (data: any) => ({
	type: SectionWiseFetchDetailsTypes.SECTION_WISE_FETCH_SUCCESS,
	payload: data,
});

export const sectionWiseFetchFailure = (error: unknown) => ({
	type: SectionWiseFetchDetailsTypes.SECTION_WISE_FETCH_FAILURE,
	payload: error,
});

export const sectionWiseFetchResponseChanged = () => ({
	type: SectionWiseFetchDetailsTypes.SECTION_WISE_FETCH_RESPONSE_CHANGED,
});

export const sectionWiseFetchResponseRestStart = () => ({
	type: SectionWiseFetchDetailsTypes.SECTION_WISE_FETCH_RESPONSE_REST_START,
});
